import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Drawer as DxDrawer } from 'devextreme-react/drawer'
import { ScrollView } from 'devextreme-react/scroll-view'

import {
    NavBar,
    DrawerMenu,
    ActionPanel,
    GlobalFilter
} from 'layout'

import { CommonRunTime } from 'layout/common-run-time/common-run-time'

import { DrawerState } from 'helpers/drawer-state-enum'
import { TabsPanel } from 'components/tabs-panel'
import { NotificationBox } from 'components/notification-box'

import { RootState } from 'slices'

import './drawer.scss'
import {createSelector} from '@reduxjs/toolkit'


const panelsStateSelector = createSelector(
    [
        (state: RootState) => state.ui.drawerState,
        (state: RootState) => state.ui.tabsPanelState,
        (state: RootState) => state.ui.actionPanelState,
        (state: RootState) => state.ui.tabs.length,
    ],
    (drawerState, tabsPanelState, actionPanelState, tabsVisible) => ({
        drawerState, tabsPanelState, actionPanelState, tabsVisible
    })
)


export const Drawer = (props: any) => {
    const { drawerState, tabsPanelState, actionPanelState, tabsVisible } = useSelector(panelsStateSelector)
    const actionsVisible = useSelector((state: RootState) => state.actionPanel.actionsVisible)
    const renderMenu = useCallback(() => {
        return (
            <DrawerMenu />
        )
    }, [])

    const setScrollViewPosition = useCallback(() => {
        const actionPanelConf = {
            'left': { marginLeft: 15, marginRight: -20 },
            'right': { marginLeft: -20, marginRight: 15 },
            'top': { marginLeft: -20, marginRight: -20 },
        }
        const tabsPanelConf = {
            'left': { marginLeft: 25, marginRight: -20 },
            'right': { marginLeft: -20, marginRight: 30 },
            'top': { marginLeft: -20, marginRight: -20 },
        }
        const actionBar = actionsVisible ? actionPanelConf[actionPanelState] : { marginLeft: -20, marginRight: -20 }
        const tabsBar  = tabsVisible ? tabsPanelConf[tabsPanelState] : { marginLeft: -20, marginRight: -20 }
        const tinyMenu = drawerState === DrawerState.Closed ? 40 : 0
        const marginLeft = actionBar.marginLeft + tabsBar.marginLeft + tinyMenu
        const marginRight = actionBar.marginRight + tabsBar.marginRight

        return {marginLeft: marginLeft, marginRight: marginRight}

    }, [drawerState, tabsPanelState, actionPanelState, actionsVisible, tabsVisible])

    return (
        <DxDrawer
            minSize={0}
            revealMode='expand'
            render={renderMenu}
            openedStateMode='shrink'
            opened={drawerState !== DrawerState.Closed}
        >
            <div id='view'>
                <div id='ix-toolbars' className='toolbars-container'>
                    <div id='ix-toolbars-nav'>
                        <NavBar />
                    </div>

                    <div id='ix-toolbars-global-filters'>
                        <GlobalFilter />
                    </div>

                    <div id='ix-toolbars-tabs'>
                        <TabsPanel />
                    </div>

                    <div id='ix-toolbars-actions'>
                        <ActionPanel />
                    </div>

                    <div id='sbanner'>
                    </div>

                    <NotificationBox />
                </div>
                <ScrollView id='content'>
                    <div className='container' style={setScrollViewPosition()}>
                        {props.children}
                    </div>
                </ScrollView>

                <div
                    id='speed-actions-container'
                    style={ { position: 'absolute', bottom: '51px', right: '16px' } }
                />
                <CommonRunTime />
            </div>
        </DxDrawer>
    )
}
